import * as Vue from "vue";
import * as mutations from "./../../mutation-types"

export const processNotification = (store, item) => {
    store.commit(mutations.ADD_OR_UPDATE_NOTIFICATION, item)
}

export const removeNotification = (store, item) => {
    store.commit(mutations.REMOVE_NOTIFICATION, item)
}

export const fetchNotifications = (store, params) => {
    return axios.get(`/api/notifications`, { params })
        .then(res => {
            _.each(res.data.data, item => processNotification(store, item))
            return res
        })
}

export const fetchUnreadLatest5Notifications = (store, params) => {
    return axios.get(`/api/notifications/unreadLatest5`, { params })
        .then(res => {
            store.commit(mutations.ADD_OR_UPDATE_NOTIFICATION_COUNT, res.data.pagination.total)
            _.each(res.data.data, item => processNotification(store, item))
            return res
        })
}

export const readNotification = (store, item) => {
    return axios.patch(`/api/notifications/${item.id}/read`)
        .then(res => {
            processNotification(store, res.data.data)
            window.location.reload()
            return res
        })
}

export const readAllNotifications = (store) => {
    return axios.patch(`/api/notifications/readall`)
        .then(res => {
            return res
        })
}

export const dismissNotification = (store, item) => {
    removeNotification(store, item)
    return axios.delete(`/api/notifications/${item.id}/dismiss`)
        .then(res => {
            window.location.reload()
            return res
        })
}

export const dismissAllNotifications = (store) => {
    return axios.delete(`/api/notifications/dismissall`)
        .then(res => {
            return res
        })
}
